import { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { styled } from '@mui/material';
import { Coverage } from '../../../../../../Typescript/classes';
import { NumberInput } from '@calefy-inc/informedMaterial';
import { Form } from 'informed';
import { displayPerilLimits } from '../utility';
import {
  WithFormStyles,
  withFormStyles,
} from '../../../../../../util/withFormStyles';

interface SetTotalPropertyPremiumProps extends WithFormStyles {
  propertyInformation: Array<PropertyInformation>;
}
export const SetTotalPropertyPremium = withFormStyles()(
  ({ propertyInformation }: SetTotalPropertyPremiumProps) => {
    const [existingTotalPremium, setTotalExistingPremium] = useState<
      number | undefined
    >();
    const [desiredTotal, setDesiredTotal] = useState<number | undefined>();

    // set the existing total once we have the information
    useEffect(() => {
      if (propertyInformation.length > 0) {
        const existingPremium = propertyInformation.reduce((sum, info) => {
          return sum + info.total;
        }, 0);
        setTotalExistingPremium(existingPremium);
        setDesiredTotal(existingPremium);
      }
    }, [propertyInformation]);

    return (
      <SetTotalPropertyPremiumContainer>
        {existingTotalPremium !== undefined ? (
          <Typography>
            Total Property Premium:{' '}
            <strong>{displayPerilLimits(existingTotalPremium)}</strong>
          </Typography>
        ) : null}
        <Form
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'end',
            gap: '2rem',
          }}
          onSubmit={
            (formState) => {
              const { values } = formState;
              const desiredTotal = values.desiredTotal !== undefined ? Number(values.desiredTotal) : undefined;
              if (
                desiredTotal === undefined ||
                existingTotalPremium === undefined
              ) {
                return;
              }
              const adjustmentFactor = desiredTotal / existingTotalPremium;
              propertyInformation.forEach((propertyInfo) => {
                const { total, updateAmount } = propertyInfo;
                const newTotalPremium = total * adjustmentFactor;
                if (updateAmount) {
                  updateAmount(newTotalPremium);
                }
              });
            }
          }
        >
          <NumberInput
            name='desiredTotal'
            label='Desired Total'
            value={desiredTotal?.toFixed(2)}
          />
          <Button
            type='submit'
            variant='outlined'
            disabled={
              desiredTotal === undefined || existingTotalPremium === undefined
            }
          >
            Update Property Rates
          </Button>
        </Form>
      </SetTotalPropertyPremiumContainer>
    );
  },
);
const SetTotalPropertyPremiumContainer = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(4),
    margin: theme.spacing(2, 0),
    alignItems: 'baseline',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  };
});

export interface PropertyInformation {
  id: Coverage['id'];
  total: number;
  updateAmount?: (newTotal: number) => void;
}

export const arePropertyInformationsDifferent = (
  first: PropertyInformation,
  second: PropertyInformation,
): boolean => {
  if (first.id !== second.id) {
    return true;
  }
  if (Math.abs(first.total - second.total) > 0.01) {
    return true;
  }
  // if (first.updateAmount !== second.updateAmount) {
  //   return true;
  // }
  return false;
};
